import { ViewChanger } from "./ViewChanger";

export const ButtonGroups = {
  ViewChanger
};
